import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ORDERS_PAGE_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { OrdersPageBlockScenarioContent } from '@front-platform/content-builder';

import {
  ORDERS_PAGE_BLOCK_LOADING_VM,
  OrdersPageBlockDataSource,
  OrdersPageBlockViewModel,
} from './orders-page-block-view-model';

export function toOrdersPagePreviewViewModel(
  content: OrdersPageBlockScenarioContent,
): OrdersPageBlockViewModel {
  return {
    activeOrders: content.activeOrders as unknown as OrdersPageBlockViewModel['activeOrders'],
    historicalOrders:
      content.historicalOrders as unknown as OrdersPageBlockViewModel['historicalOrders'],
    isActiveOrdersLoading: content.isActiveOrdersLoading,
    isHistoricalOrdersLoading: content.isHistoricalOrdersLoading,
  };
}

@Injectable()
export class OrdersPageBlockPreviewDataSource implements OrdersPageBlockDataSource {
  readonly vm$: Observable<OrdersPageBlockViewModel> = previewScenarioForBloc$(
    ORDERS_PAGE_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return ORDERS_PAGE_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<OrdersPageBlockScenarioContent>(
        scenario,
        ORDERS_PAGE_BLOCK_COMPONENT,
      );
      return content ? toOrdersPagePreviewViewModel(content) : ORDERS_PAGE_BLOCK_LOADING_VM;
    }),
  );
}
